import { useSessionStorage } from "@vueuse/core";

export default defineNuxtRouteMiddleware((from, to) => {
  const backendStore = useBackendStore();
  const isEmbedState = useState("isEmbed", () => false);

  const { hostname } = useRequestURL();

  if (hostname.split(".")[0] === "embed") {
    backendStore.setIsEmbed(true);
    const cookie = useSessionStorage(
      "client_token", // Klucz jest identyczny jak nazwa ciasteczka
      null, // Wartość początkowa, np. null lub pusty string
      {
        serializer: {
          // Zapewnienie, że token jest traktowany jako string, a nie JSON
          read: (v) => v,
          write: (v) => v || "",
        },
      }
    );
    const tokenFromQuery = to.query.embed_client_token;

    if (tokenFromQuery) {
      cookie.value = tokenFromQuery;
    }
  } else {
    backendStore.setIsEmbed(false);
    isEmbedState.value = false;
  }
});
